import React, { FC } from 'react';
// mui components
import { Box, CircularProgress, CircularProgressProps, Typography } from '@mui/material';

import CheckIcon from 'assets/icons/Check_icon.svg';

interface IRoundProgressProps extends CircularProgressProps {
  value: number;
  textSize?: number;
}

export const RoundProgress: FC<IRoundProgressProps> = (props) => {
  const percent = Math.round(props.value);
  const { textSize, ...restProps } = props;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...restProps} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{
            fontFamily: 'Inter',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: textSize ? `${textSize}px !important` : '10px',
            lineHeight: '150%',
            display: 'flex',
            color: '#23252F',
          }}
        >
          {percent === 100 ? <CheckIcon /> : `${percent}%`}
        </Typography>
      </Box>
    </Box>
  );
};
